import React, { useEffect, useState } from "react";
import "../Manage Projects/viewProjects.css"; // reuse existing CSS
import "./ViewFinancePartner.css"; // new CSS file for popup styles
import SearchBar from "../Main/searchBar";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch } from "react-redux";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import { viewFinancePartner, listFinancePartnerUsers } from "../../Redux/Actions/financePartnersActions";

const ViewFinancePartner = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [status, setStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [financePartner, setFinancePartner] = useState(null);

  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(viewFinancePartner(id)).then((res) => {
        if (res?.data) {
          setFinancePartner(res.data);
          if (res.data.status) setStatus(res.data.status);
        }
      });
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(listFinancePartnerUsers(id, page, limit)).then((res) => {
        if (res?.data) {
          setUsers(res.data);
          if (res.total) setTotalUsers(res.total);
        }
      });
    }
  }, [id, page, limit, dispatch]);

  if (!financePartner) {
    return <div>Loading...</div>;
  }

  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gridAutoRows: "minmax(60px, auto)" }}
      className="padding-20 gap-10 grid-container"
    >
      <div style={{ gridColumn: "3/8" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div className="back-icon margin-0 gap-10 align-center flex-container" style={{ gridColumn: "span 7" }}>
        <Link to="/finance_partners">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>{financePartner.company_name || "Finance Partner Details"}</h3>
          <h4 style={{ position: "relative", top: "-10px" }}>
            Finance Partner / List / View
          </h4>
        </div>
      </div>

      <div className="overall-container" style={{ opacity: isUpdating ? 0.6 : 1 }}>
        <div className="flex-container flex-justify-between border-24 align-center padding-20 flex-wrap finance-partner-details">
          <Field label="Company Name" value={financePartner.company_name} />
          <Field label="Contact Number" value={`${financePartner.country_code || ""} ${financePartner.contact_number || ""}`} />
          <Field label="Address" value={financePartner.address} />
          <Field label="Country" value={financePartner.country?.country_name} />
          <Field label="State" value={financePartner.state?.state_name} />
          <Field label="City" value={financePartner.city?.city_name} />
          <Field label="About" value={financePartner.about} />
          <Field label="Status" value={ToFirstCapital(status)} />
          <Field label="Created At" value={financePartner.created_at ? DateToLocale(financePartner.created_at) : "No Data"} />
          {/* Button to Show Popup */}
        <div style={{ marginTop: 20 }}>
          <button className="btn-primaryy" onClick={() => setShowPopup(true)}>
            Show Users
          </button>
        </div>
        </div>

        

        {/* Popup Modal */}
        {showPopup && (
          <div className="popup-overlay" onClick={() => setShowPopup(false)}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <h2>User Details</h2>
              <table className="user-table">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Employment Type</th>
                    <th>Property Size</th>
                    <th>Property Value</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Loan Tenure</th>
                    <th>Loan Amount</th>
                    <th>Mobile</th>
                    <th>Monthly Salary</th>
                    <th>Product Type</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user._id}>
                      <td>{user.email || "N/A"}</td>
                      <td>{user.employment_type || "N/A"}</td>
                      <td>{user.estimated_property_size ?? "N/A"}</td>
                      <td>{user.estimated_property_value ?? "N/A"}</td>
                      <td>{user.first_name || "N/A"}</td>
                      <td>{user.last_name || "N/A"}</td>
                      <td>{user.loan_tenure ?? "N/A"}</td>
                      <td>{user.loan_amount ?? "N/A"}</td>
                      <td>{user.mobile || "N/A"}</td>
                      <td>{user.monthly_salary ?? "N/A"}</td>
                      <td>{user.product_type || "N/A"}</td>
                      <td>{user.created_at ? new Date(user.created_at).toLocaleString() : "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn-close" onClick={() => setShowPopup(false)}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Field = ({ label, value }) => (
  <div className="flex-container flex-column" style={{ minWidth: 200, margin: 10 }}>
    <span className="span-column" style={{ color: "#999" }}>{label}</span>
    <h2 className="h2-column" style={{ color: "white" }}>{value ?? "No Data"}</h2>
  </div>
);

export default ViewFinancePartner;
